import type { ReactElement } from 'react'
import { Navigate } from 'react-router-dom'
import { ContentSkeleton } from '@/components/loading/Skeleton'
import { useAuth } from '@/state/AuthContext'
import { canUseDirector } from '@/lib/features'
import { isViewer } from '@/components/auth/isViewer'

/** AI Producer pages: for organisations with the director turned on. Viewers go home. */
export function DirectorRoute({ children }: { children: ReactElement }) {
  const { isAuthenticated, organization, user, authReady } = useAuth()

  if (!isAuthenticated) return <Navigate to="/login" replace />

  if (!authReady) {
    return (
      <div className="flex min-h-screen items-center justify-center text-sm text-neutral-7">
        <ContentSkeleton label="Loading workspace" variant="viewer" className="max-w-7xl px-6" />
      </div>
    )
  }

  if (isViewer(organization, user)) return <Navigate to="/" replace />
  return canUseDirector(organization, authReady) ? children : <Navigate to="/app" replace />
}
